var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PickType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { transformAndValidateSync } from "class-transformer-validator";
import { IsArray, IsBoolean, IsEnum, IsNumber, IsOptional, isURL, ValidateNested } from "class-validator";
import { DocumentRetrievalAuthType, DocumentRetrievalTaskSource } from "./document.retrieval.dtos";
import { RoEcwLookupConfig, RoFastenEpicLookupConfig, RoFastenOracleLookupConfig, TefcaEndpointOverrideConfig, } from "./feature.tefca.endpoint.override.dtos";
import { retrievalStatsConfigDecoder } from "./features/retrieval.stats.dtos";
import { asEnum, enumValues } from "./utils";
export { resolveRetrievalStatsToggles, RetrievalStatsConfig, RetrievalStatsToggles } from "./features/retrieval.stats.dtos";
export { FastenEndpointRef, isForceFastenEndpoint, RoEcwLookupConfig, RoFastenEpicLookupConfig, RoFastenOracleLookupConfig, RoForceFastenEndpointsConfig, TefcaEndpointOverrideConfig, TefcaEndpointOverrideMatchCriteria, TefcaEndpointOverrideRule, TefcaEndpointOverrideTarget, TefcaEndpointOverrideTargetMetadata, } from "./feature.tefca.endpoint.override.dtos";
export var TefcaProvider;
(function (TefcaProvider) {
    TefcaProvider["CommonWell"] = "CommonWell";
    TefcaProvider["MedAllies"] = "MedAllies";
    TefcaProvider["HxTest"] = "HxTest";
})(TefcaProvider || (TefcaProvider = {}));
export function nonTestTefcaProviders() {
    return enumValues(TefcaProvider).filter((provider) => provider !== TefcaProvider.HxTest);
}
export var ClearUpgradeUxVariant;
(function (ClearUpgradeUxVariant) {
    ClearUpgradeUxVariant["MANUAL_FORWARD"] = "MANUAL_FORWARD";
    ClearUpgradeUxVariant["CLEAR_FORWARD"] = "CLEAR_FORWARD";
    ClearUpgradeUxVariant["LEGACY_CLEAR_FORWARD"] = "LEGACY_CLEAR_FORWARD";
})(ClearUpgradeUxVariant || (ClearUpgradeUxVariant = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["RO_PARTICLE_HEALTH"] = "RO_PARTICLE_HEALTH";
    FeatureFlag["RO_CLEAR_LOGIN_FALLBACK"] = "RO_CLEAR_LOGIN_FALLBACK";
    FeatureFlag["RO_TEFCA_ORGANIZATION_LOGOS"] = "RO_TEFCA_ORGANIZATION_LOGOS";
    FeatureFlag["RO_FASTEN_EPIC_LOOKUP"] = "RO_FASTEN_EPIC_LOOKUP";
    FeatureFlag["RO_ECW_LOOKUP"] = "RO_ECW_LOOKUP";
    FeatureFlag["RO_ORACLE_LOOKUP"] = "RO_ORACLE_LOOKUP";
    FeatureFlag["TEFCA_ENDPOINT_OVERRIDE"] = "TEFCA_ENDPOINT_OVERRIDE";
    FeatureFlag["RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS"] = "RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS";
    FeatureFlag["RO_DEDUPE_NAME_NORMALIZATION"] = "RO_DEDUPE_NAME_NORMALIZATION";
    FeatureFlag["CLEAR_LOGIN_FALLBACK_RESET"] = "CLEAR_LOGIN_FALLBACK_RESET";
    FeatureFlag["DOCUMENT_RETRIEVAL_PATIENT_FLOW"] = "DOCUMENT_RETRIEVAL_PATIENT_FLOW";
    FeatureFlag["PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN"] = "PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN";
    FeatureFlag["DATA_DELIVERY_PATH_AS_FILENAME_PREFIX"] = "DATA_DELIVERY_PATH_AS_FILENAME_PREFIX";
    FeatureFlag["TEFCA_PROVIDERS"] = "TEFCA_PROVIDERS";
    FeatureFlag["ORG_TEFCA_PROVIDER"] = "ORG_TEFCA_PROVIDER";
    FeatureFlag["GLOBAL_ENABLED_TEFCA_PROVIDERS"] = "GLOBAL_ENABLED_TEFCA_PROVIDERS";
    FeatureFlag["HX_TEST_PATIENTS_ENABLED"] = "HX_TEST_PATIENTS_ENABLED";
    FeatureFlag["RO_CLEAR_UPGRADE_UX"] = "RO_CLEAR_UPGRADE_UX";
    FeatureFlag["ONLY_CLEAR_LOGIN_ALLOWED"] = "ONLY_CLEAR_LOGIN_ALLOWED";
    FeatureFlag["APPLE_LOGIN_BUTTON_ENABLED"] = "APPLE_LOGIN_BUTTON_ENABLED";
    FeatureFlag["COMMUNITY_AUTH"] = "COMMUNITY_AUTH";
    FeatureFlag["BACKGROUND_DATA_REFRESH"] = "BACKGROUND_DATA_REFRESH";
    FeatureFlag["PATIENT_NUDGE_NOTIFICATIONS"] = "PATIENT_NUDGE_NOTIFICATIONS";
    FeatureFlag["SURVEY_NOTIFICATIONS_ENABLED"] = "SURVEY_NOTIFICATIONS_ENABLED";
    FeatureFlag["RO_HEALTH_WALLET_ENABLED"] = "RO_HEALTH_WALLET_ENABLED";
    FeatureFlag["RO_HEALTH_WALLET_SOURCES_ENABLED"] = "RO_HEALTH_WALLET_SOURCES_ENABLED";
    FeatureFlag["RO_ADD_RECORD_LOCATIONS_DIRECTLY"] = "RO_ADD_RECORD_LOCATIONS_DIRECTLY";
    FeatureFlag["HOSTED_IDP_SSO_ENABLED"] = "HOSTED_IDP_SSO_ENABLED";
    FeatureFlag["CLINICAL_AI_SKILLS_ENABLED"] = "CLINICAL_AI_SKILLS_ENABLED";
    FeatureFlag["AI_DATA_USE_RECORDS_READY_EMAIL_DELAY"] = "AI_DATA_USE_RECORDS_READY_EMAIL_DELAY";
    FeatureFlag["RETRIEVAL_STATS_GATHERING"] = "RETRIEVAL_STATS_GATHERING";
    FeatureFlag["TEST"] = "TEST";
    FeatureFlag["TEST2"] = "TEST2";
    FeatureFlag["TEST3"] = "TEST3";
    FeatureFlag["TEST4"] = "TEST4";
})(FeatureFlag || (FeatureFlag = {}));
export const nullDecoder = () => null;
const dateDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    const date = new Date(rawConfig);
    return Number.isNaN(date.getTime()) ? null : date;
};
const createStringArrayDecoder = (enumType) => {
    const validValues = enumType ? new Set(Object.values(enumType)) : null;
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        try {
            const parsed = JSON.parse(rawConfig);
            if (!Array.isArray(parsed))
                return null;
            const isValidItem = (item) => typeof item === "string" && (!validValues || validValues.has(item));
            if (!parsed.every(isValidItem))
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    };
};
const createURLArrayDecoder = () => {
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        try {
            const parsed = JSON.parse(rawConfig);
            if (!Array.isArray(parsed))
                return null;
            const isValidItem = (item) => typeof item === "string" && isURL(item, { protocols: ["http", "https"], require_tld: false, require_protocol: true });
            if (!parsed.every(isValidItem))
                return null;
            return parsed;
        }
        catch {
            return null;
        }
    };
};
const INVALID_NUMBER_FIELD = Symbol("invalidNumberField");
function readOptionalNumberField(parsed, field, isAcceptable = () => true) {
    var _a;
    const value = (_a = Object.getOwnPropertyDescriptor(parsed, field)) === null || _a === void 0 ? void 0 : _a.value;
    if (value === undefined)
        return undefined;
    return typeof value === "number" && Number.isFinite(value) && isAcceptable(value) ? value : INVALID_NUMBER_FIELD;
}
const backgroundDataRefreshDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        const minimumDaysSinceLastRetrieval = readOptionalNumberField(parsed, "minimumDaysSinceLastRetrieval");
        const maximumSetSize = readOptionalNumberField(parsed, "maximumSetSize");
        if (minimumDaysSinceLastRetrieval === INVALID_NUMBER_FIELD || maximumSetSize === INVALID_NUMBER_FIELD)
            return null;
        const result = {};
        if (minimumDaysSinceLastRetrieval !== undefined)
            result.minimumDaysSinceLastRetrieval = minimumDaysSinceLastRetrieval;
        if (maximumSetSize !== undefined)
            result.maximumSetSize = maximumSetSize;
        return result;
    }
    catch {
        return null;
    }
};
const aiRecordsReadyEmailDelayDecoder = (rawConfig) => {
    if (!rawConfig)
        return { delaySeconds: 0 };
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        const delaySeconds = readOptionalNumberField(parsed, "delaySeconds", (value) => value >= 0);
        if (delaySeconds === INVALID_NUMBER_FIELD)
            return null;
        return { delaySeconds: delaySeconds !== null && delaySeconds !== void 0 ? delaySeconds : 0 };
    }
    catch {
        return null;
    }
};
export class PatientNudgeNotificationsConfig {
}
__decorate([
    IsNumber(),
    IsOptional()
], PatientNudgeNotificationsConfig.prototype, "delayMinutes", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientNudgeNotificationsConfig.prototype, "progressExpirationMinutes", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], PatientNudgeNotificationsConfig.prototype, "maxNudgesPerFlow", void 0);
const patientNudgeNotificationsDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        return transformAndValidateSync(PatientNudgeNotificationsConfig, parsed, {
            validator: { whitelist: true },
        });
    }
    catch {
        return null;
    }
};
const tefcaEndpointOverrideDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        const config = transformAndValidateSync(TefcaEndpointOverrideConfig, parsed, {
            validator: { whitelist: true, forbidNonWhitelisted: true },
        });
        config.overrideRules = config.overrideRules.filter((rule) => {
            var _a, _b;
            const hasMatchCriteria = ((_b = (_a = rule.matchCriteria.hcids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 || !!rule.matchCriteria.organizationName || !!rule.matchCriteria.fhirUrl;
            if (!hasMatchCriteria) {
                return false;
            }
            const { source, authType } = rule.overrideTarget;
            if (source !== DocumentRetrievalTaskSource.FASTEN || authType !== DocumentRetrievalAuthType.FASTEN) {
                return false;
            }
            return true;
        });
        if (config.overrideRules.length === 0) {
            return null;
        }
        return config;
    }
    catch {
        return null;
    }
};
const roFastenEpicLookupDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        return transformAndValidateSync(RoFastenEpicLookupConfig, parsed, {
            validator: { whitelist: true, forbidNonWhitelisted: true },
        });
    }
    catch {
        return null;
    }
};
const roFastenOracleLookupDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        return transformAndValidateSync(RoFastenOracleLookupConfig, parsed, {
            validator: { whitelist: true, forbidNonWhitelisted: true },
        });
    }
    catch {
        return null;
    }
};
const roEcwLookupDecoder = (rawConfig) => {
    if (!rawConfig)
        return null;
    try {
        const parsed = JSON.parse(rawConfig);
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return null;
        return transformAndValidateSync(RoEcwLookupConfig, parsed, {
            validator: { whitelist: true, forbidNonWhitelisted: true },
        });
    }
    catch {
        return null;
    }
};
const createEnumDecoder = (enumType) => {
    return (rawConfig) => {
        if (!rawConfig)
            return null;
        return asEnum(enumType)(rawConfig);
    };
};
export var FeatureFlagConfigEditorKind;
(function (FeatureFlagConfigEditorKind) {
    FeatureFlagConfigEditorKind["Json"] = "json";
    FeatureFlagConfigEditorKind["Date"] = "date";
    FeatureFlagConfigEditorKind["Enum"] = "enum";
    FeatureFlagConfigEditorKind["EnumArray"] = "enumArray";
    FeatureFlagConfigEditorKind["UrlArray"] = "urlArray";
    FeatureFlagConfigEditorKind["BackgroundDataRefresh"] = "backgroundDataRefresh";
    FeatureFlagConfigEditorKind["PatientNudgeNotifications"] = "patientNudgeNotifications";
    FeatureFlagConfigEditorKind["AiRecordsReadyEmailDelay"] = "aiRecordsReadyEmailDelay";
    FeatureFlagConfigEditorKind["RetrievalStats"] = "retrievalStats";
})(FeatureFlagConfigEditorKind || (FeatureFlagConfigEditorKind = {}));
const featureFlagRegistryEntries = {
    [FeatureFlag.RO_PARTICLE_HEALTH]: {
        description: `When enabled during TEFCA retrieval, also fetches Particle Health record locations and merges them into the patient's document retrieval batch.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_CLEAR_LOGIN_FALLBACK]: {
        description: `Allows a user to use Clear login with less stringent (not IAL2) verification. Will mean some queries (e.g TEFCA) will require a user to "upgrade" their verification.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_TEFCA_ORGANIZATION_LOGOS]: {
        description: `Fetches and attaches healthcare organization logo URLs on document retrieval locations (direct Epic pre-auth, carry-over, and TEFCA/Particle processing).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_FASTEN_EPIC_LOOKUP]: {
        description: `For Epic direct-record catalog matches, resolves native Epic FHIR endpoints via the Fasten Epic directory; optional JSON can force specific endpoints to stay on Fasten.`,
        decoder: roFastenEpicLookupDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
        configOptionalWhenEnabled: true,
    },
    [FeatureFlag.RO_ECW_LOOKUP]: {
        description: `For eClinicalWorks catalog matches, resolves vendor FHIR endpoints; optional JSON can force selected Fasten endpoint triples to remain on Fasten, and can set useIAL2Token. logRetrievalSummary is deprecated and ignored - use RETRIEVAL_STATS_GATHERING instead.`,
        decoder: roEcwLookupDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
        configOptionalWhenEnabled: true,
    },
    [FeatureFlag.RO_ORACLE_LOOKUP]: {
        description: `For Oracle catalog matches, resolves vendor FHIR endpoints; optional JSON can force selected Fasten endpoint triples to remain on Fasten.`,
        decoder: roFastenOracleLookupDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
        configOptionalWhenEnabled: true,
    },
    [FeatureFlag.TEFCA_ENDPOINT_OVERRIDE]: {
        description: `Applies rule-based overrides that remap discovered TEFCA/Fasten endpoints to configured targets during document retrieval. Rules without match criteria, or targeting anything other than a Fasten source and auth type, are ignored.`,
        decoder: tefcaEndpointOverrideDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_PATIENT_PORTAL_SEARCH_SUGGESTIONS]: {
        description: `Adds location-based patient portal suggestions to Fasten endpoint search results (deduped against Particle suggestions when both are enabled).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_DEDUPE_NAME_NORMALIZATION]: {
        description: `Normalizes organization names when matching and deduplicating document retrieval locations to reduce false duplicates from naming variation.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.CLEAR_LOGIN_FALLBACK_RESET]: {
        description: `Date config: clears stored Clear fallback on devices if fallback was last used before this date, requiring IAL2 verification again.`,
        decoder: dateDecoder,
        editor: FeatureFlagConfigEditorKind.Date,
    },
    [FeatureFlag.DOCUMENT_RETRIEVAL_PATIENT_FLOW]: {
        description: `Reserved — no production enablement checks found; kept for admin visibility and future patient-flow gating.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.PATIENT_30_DAY_EXPIRATION_HEALTHEX_TOKEN]: {
        description: `For organization-scoped refreshable patient tokens, extends access token lifetime to 30 days instead of the default refreshable expiry.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.DATA_DELIVERY_PATH_AS_FILENAME_PREFIX]: {
        description: `Prefixes S3/SFTP delivered filenames with the organization's configured data delivery path.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.TEFCA_PROVIDERS]: {
        description: `Legacy org allowlist of TEFCA providers, superseded by ORG_TEFCA_PROVIDER and GLOBAL_ENABLED_TEFCA_PROVIDERS; no runtime reads found — retained for existing DB rows.`,
        decoder: createStringArrayDecoder(TefcaProvider),
        editor: FeatureFlagConfigEditorKind.EnumArray,
        enumType: TefcaProvider,
    },
    [FeatureFlag.ORG_TEFCA_PROVIDER]: {
        description: `Default TEFCA provider for an organization when a patient has no stored per-patient provider.`,
        decoder: createEnumDecoder(TefcaProvider),
        editor: FeatureFlagConfigEditorKind.Enum,
        enumType: TefcaProvider,
    },
    [FeatureFlag.GLOBAL_ENABLED_TEFCA_PROVIDERS]: {
        description: `Global allowlist of TEFCA providers; patient and org defaults must be on this list or fall back to MedAllies.`,
        decoder: createStringArrayDecoder(TefcaProvider),
        editor: FeatureFlagConfigEditorKind.EnumArray,
        enumType: TefcaProvider,
    },
    [FeatureFlag.HX_TEST_PATIENTS_ENABLED]: {
        description: `Allows an organization to create HX test patients via the test-patient API (requires special-purpose token).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_CLEAR_UPGRADE_UX]: {
        description: `Selects Clear identity upgrade UX during patient consent (MANUAL_FORWARD, CLEAR_FORWARD, or LEGACY_CLEAR_FORWARD).`,
        decoder: createEnumDecoder(ClearUpgradeUxVariant),
        editor: FeatureFlagConfigEditorKind.Enum,
        enumType: ClearUpgradeUxVariant,
    },
    [FeatureFlag.ONLY_CLEAR_LOGIN_ALLOWED]: {
        description: `Restricts patient consent login to Clear only (hides other login methods).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.APPLE_LOGIN_BUTTON_ENABLED]: {
        description: `Shows Apple Sign In on the patient consent login screen.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.COMMUNITY_AUTH]: {
        description: `For listed Epic FHIR base URLs, uses Epic community OAuth scopes instead of patient scopes during facilitated Epic authorization.`,
        decoder: createURLArrayDecoder(),
        editor: FeatureFlagConfigEditorKind.UrlArray,
    },
    [FeatureFlag.BACKGROUND_DATA_REFRESH]: {
        description: `Enables scheduled background document retrieval refresh for active patients past a configurable minimum interval since last batch or refresh.`,
        decoder: backgroundDataRefreshDecoder,
        editor: FeatureFlagConfigEditorKind.BackgroundDataRefresh,
    },
    [FeatureFlag.PATIENT_NUDGE_NOTIFICATIONS]: {
        description: `Enables consent-flow nudge notifications for patients who stall mid-flow (delay, progress expiry, and max nudges configurable).`,
        decoder: patientNudgeNotificationsDecoder,
        editor: FeatureFlagConfigEditorKind.PatientNudgeNotifications,
    },
    [FeatureFlag.SURVEY_NOTIFICATIONS_ENABLED]: {
        description: `Queues a survey notification after document retrieval batch finalization for study-initiated batches.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_HEALTH_WALLET_ENABLED]: {
        description: `Enables Health Wallet for the patient (records UI and notification routing).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_HEALTH_WALLET_SOURCES_ENABLED]: {
        description: `Shows the Timeline/Sources tab switch on the patient records screen. Disabled shows Timeline only, with no switch.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.RO_ADD_RECORD_LOCATIONS_DIRECTLY]: {
        description: `Allows starting a document retrieval batch that carries forward existing locations without a new search (patient or MCP origin).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.HOSTED_IDP_SSO_ENABLED]: {
        description: `For studies, allows SSO login when the IdP issuer matches the owning organization's allowed hosted IdP issuers.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.CLINICAL_AI_SKILLS_ENABLED]: {
        description: `Enables clinical AI skill tools on the patient MCP server.`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.AI_DATA_USE_RECORDS_READY_EMAIL_DELAY]: {
        description: `When enabled for an organization, defers AI data-use "records ready" patient emails; optional delaySeconds in configuration.`,
        decoder: aiRecordsReadyEmailDelayDecoder,
        editor: FeatureFlagConfigEditorKind.AiRecordsReadyEmailDelay,
        configOptionalWhenEnabled: true,
    },
    [FeatureFlag.RETRIEVAL_STATS_GATHERING]: {
        description: `Diagnostic stat gathering during and after document retrieval: a per-location record summary and per-location FHIR resource-id conformance stats, logged at retrieval time for facilitated FHIR and again post-ingestion for every source. Enabling with no configuration turns both on; each can be switched off individually.`,
        decoder: retrievalStatsConfigDecoder,
        editor: FeatureFlagConfigEditorKind.RetrievalStats,
        configOptionalWhenEnabled: true,
    },
    [FeatureFlag.TEST]: {
        description: `Internal unit-test flag (boolean only, no config).`,
        decoder: nullDecoder,
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.TEST2]: {
        description: `Internal unit-test flag (date configuration validation).`,
        decoder: dateDecoder,
        editor: FeatureFlagConfigEditorKind.Date,
    },
    [FeatureFlag.TEST3]: {
        description: `Internal unit-test flag (string array configuration validation).`,
        decoder: createStringArrayDecoder(),
        editor: FeatureFlagConfigEditorKind.Json,
    },
    [FeatureFlag.TEST4]: {
        description: `Internal unit-test flag (TefcaProvider enum array validation).`,
        decoder: createStringArrayDecoder(TefcaProvider),
        editor: FeatureFlagConfigEditorKind.EnumArray,
        enumType: TefcaProvider,
    },
};
const featureFlagRegistry = featureFlagRegistryEntries;
export function featureFlagConfigDecoder(feature) {
    return featureFlagRegistry[feature].decoder;
}
export function featureFlagConfigEditorKind(feature) {
    return featureFlagRegistry[feature].editor;
}
export function featureFlagHasOptionalConfigWhenEnabled(feature) {
    return featureFlagRegistry[feature].configOptionalWhenEnabled === true;
}
export function featureFlagConfigEnumType(feature) {
    return featureFlagRegistry[feature].enumType;
}
export function getFeatureDescription(feature) {
    return featureFlagRegistry[feature].description;
}
export class Feature {
    constructor(fields) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
    decodeConfiguration() {
        try {
            return featureFlagRegistry[this.feature].decoder(this.configuration);
        }
        catch (error) {
            return null;
        }
    }
}
__decorate([
    IsEnum(FeatureFlag)
], Feature.prototype, "feature", void 0);
__decorate([
    IsBoolean()
], Feature.prototype, "enabled", void 0);
__decorate([
    IsOptional()
], Feature.prototype, "configuration", void 0);
export class FeatureUpdateInput extends PickType(Feature, ["feature", "enabled", "configuration"]) {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
export class FeaturesDto {
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => Feature)
], FeaturesDto.prototype, "features", void 0);
